import { commonStyles, buttonStyle } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';

export const DiscoverRatesSearchBarStyles = (theme) => ({
  modeDiv: {
    backgroundColor: '#222222',
    color: tokens.colors.bgWhite,
    padding: tokens.spacing.sm,
    ...commonStyles(theme).flexColumn,
    justifyContent: 'center',
    borderRadius: `${tokens.radius.md}px 0 0 ${tokens.radius.md}px`,
  },
  centerAlign: {
    display: 'flex',
    justifyContent: 'center',
  },
  optionsDiv: {
    background: tokens.colors.bgWhite,
    borderRight: '2px solid #f9f9f9',
    padding: `${tokens.spacing.sm}px ${tokens.spacing.sm}px 0px ${tokens.spacing.sm}px`,
  },
  optionsRelativeDiv: {
    background: tokens.colors.bgWhite,
    borderRight: '2px solid #f9f9f9',
    padding: `${tokens.spacing.sm}px ${tokens.spacing.sm}px 0px ${tokens.spacing.sm}px`,
    position: 'relative',
  },
  selectTitle: {
    fontSize: tokens.fontSize.caption,
    color: '#666666',
  },
  select: {
    width: '100%',
    zIndex: 1000,
    '& .ant-select-selection--single': {
      border: 'unset',
      boxShadow: 'unset !important',
      '& .ant-select-selection__rendered': {
        marginRight: 0,
        marginLeft: 0,
        '& .ant-select-selection-selected-value': {
          fontSize: tokens.fontSize.h3,
          fontWeight: tokens.fontWeight.semibold,
        },
        '& .ant-select-search--inline .ant-select-search__field': {
          fontSize: tokens.fontSize.h3,
          fontWeight: tokens.fontWeight.semibold,
        },
      },
    },
  },
  search: {
    fontSize: tokens.fontSize.h2,
    width: '100%',
    height: '100%',
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: `0 ${tokens.radius.md}px ${tokens.radius.md}px 0`,
    backgroundColor: tokens.colors.primaryDark,
    border: `1px solid ${tokens.colors.primaryDark}`,
    color: tokens.colors.bgWhite,
    '&:hover': {
      backgroundColor: '#037DDC',
      border: `1px solid ${tokens.colors.primaryDark}`,
      color: tokens.colors.bgWhite,
    },
    '&:focus': {
      backgroundColor: tokens.colors.primaryDark,
      border: `1px solid ${tokens.colors.primaryDark}`,
      color: tokens.colors.bgWhite,
    },
  },
  searchDisabled: {
    ...buttonStyle(
      '#FFFFFF !important',
      '#B8B8B8 !important',
      '1px solid #B8B8B8 !important',
    ),
    cursor: 'not-allowed',
  },
  countryName: {
    fontSize: tokens.fontSize.caption,
    marginLeft: '10px',
    fontWeight: 'normal',
  },
  dropDownStyle: {
    minWidth: '0 !important',
    '& .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title': {
      '&:hover': {
        backgroundColor: tokens.colors.primaryDark,
        color: tokens.colors.bgWhite,
      },
    },
  },
  mode: {
    ...commonStyles(theme).flexRow,
    marginTop: '5px',
    backgroundColor: '#000',
    border: 'none',
    color: 'white'
  },
  dropdown: {
    '& .ant-select-dropdown-menu': {
      '& .ant-select-dropdown-menu-item-selected': {
        backgroundColor: tokens.colors.primaryDark,
        color: tokens.colors.bgWhite,
      },
      '& .ant-select-dropdown-menu-item': {
        '&:hover': {
          backgroundColor: tokens.colors.primaryDark,
          color: tokens.colors.bgWhite,
        },
      },
    },
  },
  recentSearches: {
    display: 'flex',
  },
  recentSearchCard: {
    fontSize: tokens.fontSize.caption,
    border: `1px solid ${tokens.colors.textSecondary}`,
    padding: '0px 6px',
    marginRight: tokens.spacing.ms,
    cursor: 'pointer',
    borderRadius: tokens.radius.sm,
  },
  errorMessage: {
    marginBottom: 0,
    '& .ant-form-explain': {
      fontSize: tokens.fontSize.caption,
    },
  },
  dropdownDiv: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
    maxWidth: '300px',
  },
  countryCode: {
    marginRight: '6px',
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.semibold,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '262px',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  dryPort: {
    backgroundColor: '#DBECFB',
    color: '#1C4B78',
    fontSize: tokens.fontSize.caption,
    border: '1px solid #1C4B78',
    borderRadius: tokens.radius.sm,
    padding: '0px 3px',
    verticalAlign: 'top',
  },
  viewDiv: {
    border: `1px solid ${tokens.colors.textSecondary}`,
    borderRadius: tokens.radius.md,
    padding: `${tokens.spacing.xxs}px ${tokens.spacing.xs}px`,
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    marginRight: tokens.spacing.xs,
    cursor: 'pointer',
    '&:hover': {
      color: 'rgba(51, 51, 51, 0.8) !important',
      border: '1px solid rgba(51, 51, 51, 0.8)',
      backgroundColor: '#F0E4C4 !important',
    },
  },
  landingPageOptions: {
    background: tokens.colors.bgWhite,
    padding: `10px ${tokens.spacing.md}px`,
    width: '100% !important',
    ...commonStyles(theme).flexRow,
    borderBottom: '2px solid #E3D3A9',
  },
  landingPageErrorMessage: {
    marginBottom: 0,
    width: '100%',
    '& .ant-form-explain': {
      fontSize: tokens.fontSize.caption,
    },
  },
  landingPageSearch: {
    padding: '21px',
    borderRadius: tokens.radius.md,
  },
  selectTitleWidth: {
    width: '34%',
  },
  landingPageMode: {
    padding: '18px 16px',
    borderRadius: `${tokens.radius.md}px ${tokens.radius.md}px 0 0`,
  },
  landingPageCargo: {
    borderRadius: `0 0 ${tokens.radius.md}px ${tokens.radius.md}px`,
  },
  commonSearchButtonStyle: {
    padding: 0,
    borderRight: 0,
    width: '14%',
    borderRadius: `0px ${tokens.radius.md}px ${tokens.radius.md}px 0px`,
    backgroundColor: '#E3D3A9',
  },
  disableClick: {
    pointerEvents: 'none',
  },
  modeDropdown: {
    '& .ant-select-dropdown-menu': {
      '& .ant-select-dropdown-menu-item-selected': {
        backgroundColor: '#fff!important',
      },
      '& .ant-select-dropdown-menu-item': {
        '&:hover': {
          backgroundColor: '#eee',
        },
      },
    },
  },
  disoverPageDropdown: {
    '& .ant-select-selection': {
      backgroundColor: '#222223',
      color: '#fff',
    }
  },
  selectMode: {
    width: '100%',
    zIndex: 1000,
    '& .ant-select-selection--single': {
      border: 'unset',
      boxShadow: 'unset !important',
      '& .ant-select-selection__rendered': {
        marginRight: 0,
        marginLeft: 0,
        '& .ant-select-selection-selected-value': {
          fontSize: tokens.fontSize.h3,
          fontWeight: tokens.fontWeight.semibold,
        },
        '& .ant-select-search--inline .ant-select-search__field': {
          fontSize: tokens.fontSize.h3,
          fontWeight: tokens.fontWeight.semibold,
        },
      },
    },
  },
  modeIcon: {
    display: 'inline-flex',
    // '& .anticon': {
    //   background: '#fff'
    // }
    '& .fclIcon': {
      stroke: tokens.colors.textSecondary
    },
    '& .ant-select-selection-selected-value': {
      '& .fclIcon': {
        stroke: '#fff'
      }
    }
  },
  input: {
    backgroundColor: 'transparent!important',
    border: 'none!important',
    boxShadow: 'none!important',
    width: '100%',
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.semibold,
    '& input': { padding: '4px 2px' },
    '& .ant-input-number-handler-wrap': { display: 'none'},
    '& .ant-input-number-input:placeholder-shown': { fontSize: tokens.fontSize.body }
  },
  lbhSelected: {
    '& .ant-input-number-input:placeholder-shown': { fontSize: '10px' },
    '& .ant-form-explain': {fontSize: '9px!important'},
    '& .ant-input-number-input-wrap': { fontSize: tokens.fontSize.small }
  },
  chargesApplicableCardBtn: { backgroundColor: '#DBEDCF', borderColor: '#8EA474', fontSize: tokens.fontSize.caption },
  titleDropdown: {
    width: '100%',
    zIndex: 1000,
    '& .ant-select-selection--single': {
      border: 'unset',
      boxShadow: 'unset !important',
      '& .ant-select-selection__rendered': {
        marginRight: 0,
        marginLeft: 0,
        '& .ant-select-selection-selected-value': {
          fontSize: tokens.fontSize.caption,
          fontWeight: tokens.fontWeight.semibold,
        },
        '& .ant-select-search--inline .ant-select-search__field': {
          fontSize: tokens.fontSize.caption,
          fontWeight: tokens.fontWeight.semibold,
        },
      },
    },
  },
  titleDropdownMenu: {
    '& .ant-select-dropdown-menu': {
      '& .ant-select-dropdown-menu-item-selected': {
        backgroundColor: '#fff!important',
        fontSize: tokens.fontSize.caption,
      },
      '& .ant-select-dropdown-menu-item': {
          fontSize: tokens.fontSize.caption,
          '&:hover': {
          backgroundColor: '#eee',
          fontSize: tokens.fontSize.caption,
      },
      },
    },
    '& .ant-form-item-control has-success': {
      height: '14px'
    }
  },
  unitDropdown: {
    position: 'absolute',
    '& .ant-select-selection--single': {
      background: 'transparent'
    }
  },
  multiplySymbol: { paddingTop: tokens.spacing.sm, textAlign: 'center', color: 'rgb(191 191 191)' },
  skipNowButton: {
    color: 'rgba(89, 89, 89, 0.5)',
    marginRight: '6px',
    cursor: 'pointer',
  },
  confirmButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
    marginLeft: '18px',
    padding: '0px 18px',
  },
  stuffingDestuffingType: {
    color: '#595959',
    fontSize: tokens.fontSize.caption,
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  selectedValueStyle: {
    display: 'flex',
    alignItems: 'center',
  },
  selectedCityValue:{
    maxWidth: '200px',
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  absoluteOptionsDiv: {
    padding: '2px 2px',
    position: 'absolute',
    bottom: '-23px',
    zIndex: 1,
    fontSize: tokens.fontSize.caption,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    columnGap: '5px',
    '& .ant-checkbox-inner': {
      backgroundColor: 'unset',
      border: 'solid 1px black',
      height: '12px',
      width: '12px',
    },
    '& .ant-checkbox-inner::after': {
      borderColor: tokens.colors.primaryDark,
    },
  },
  groudRadiusToggleBtn: {
    color: tokens.colors.primaryDark,
    cursor: 'pointer',
    postition: 'relative',
  },
  groupRadiusBoxContainer: {
    width: '250px',
    // bottom: '-128px',
    // zIndex: '2',
    // position: 'absolute',
    backgroundColor: tokens.colors.bgWhite,
    // right: '-217px',
    // boxShadow: '0px 0px 5px grey',
    // padding: '10px',
    display: 'grid',
    rowGap: '10px'
  },
  customSlider: {
    '& .ant-slider-track': {
      backgroundColor: tokens.colors.primaryDark,
    },
    '& .ant-slider-mark-text': {
      fontSize: tokens.fontSize.caption,
    }
  }
});
